module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/banner-dark-e9812659670d274fca2298851f87dd6e.png";